// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Kk1n","header":"ReportDetails_header__3Iuod","title":"ReportDetails_title__3N74u","left":"ReportDetails_left__Gosy7"};